export default __webpack_public_path__ + "static/pragicts-automation-banner-human-intervention-8887269c0ff489b00df73dfaa424865d.jpg";